<app-page size="narrow">
    <app-breadcrumbs [crumbs]="crumbs"></app-breadcrumbs>

    @if (form()) {
        <div [formGroup]="form()" class="sections">
            <app-section [columns]="2" description="Hoe het platform heet en bij welke klant het hoort." icon="building" title="Algemeen">
                <app-field for="name" label="Naam">
                    <mat-form-field>
                        <input formControlName="name" id="name" matInput name="name" placeholder="Bijv. Backups">
                        <mat-hint>Herkenbare naam in overzichten, breadcrumbs en meldingen.</mat-hint>
                    </mat-form-field>
                </app-field>
                <app-field label="Bedrijf">
                    <ng-select [items]="companies()" [searchable]="true" bindLabel="name" bindValue="id" formControlName="company_id" placeholder="Kies een bedrijf"></ng-select>
                    <span hint>De klant die eigenaar is van dit platform.</span>
                </app-field>
                @if (form()?.get('id').value && Functionalities.Financials | hasFunctionality) {
                    <app-field full label="Features">
                        <ng-select [items]="azureFeatures()" [multiple]="true" [searchable]="true" bindLabel="name" bindValue="id" formControlName="azure_features"></ng-select>
                    </app-field>
                }
            </app-section>

            <app-section description="Per omgeving het adres en de server waarop het draait. Vul alleen de omgevingen in die bestaan." icon="server" title="Omgevingen">
                <app-data-list class="environments" columns="120px minmax(0, 1.6fr) minmax(0, 1fr)" gap="12px">
                    <div app-data-row class="env-header" header>
                        <span>Omgeving</span><span>URL</span><span>Server IP</span>
                    </div>
                    @for (env of environments; track env.key) {
                        <div app-data-row class="env-row">
                            <span class="env-name"><span [class]="'env-dot env-' + env.key"></span>{{ env.label }}</span>
                            <app-field>
                                <mat-form-field>
                                    <input [attr.aria-label]="env.label + ' URL'" [formControlName]="env.key + '_url'" [placeholder]="env.placeholder" class="font-monospace" matInput>
                                </mat-form-field>
                            </app-field>
                            @if (env.hasServer) {
                                <app-field>
                                    <ng-select [attr.aria-label]="env.label + ' server IP'" [formControlName]="env.key + '_server_ip'" [items]="servers()" [searchable]="true" bindLabel="ip" bindValue="ip" class="font-monospace" placeholder="Kies server"></ng-select>
                                </app-field>
                            } @else {
                                <span class="ui-faint ui-help">Niet van toepassing</span>
                            }
                        </div>
                    }
                </app-data-list>
                <p class="ui-help m-0 environments-help">Server IP is de server waarop de omgeving gehost wordt. Checkpoints gebruiken deze URL's en IP's als uitgangspunt.</p>
            </app-section>

            <app-section [columns]="2" description="Periode waarin het platform actief is." icon="calendar" title="Looptijd">
                <app-field for="start_date" label="Startdatum">
                    <mat-form-field>
                        <input (focus)="pickerStart.open()" [matDatepicker]="pickerStart" [min]="minDate" formControlName="start_date" id="start_date" matInput placeholder="Startdatum">
                        <mat-datepicker-toggle [for]="pickerStart" matSuffix></mat-datepicker-toggle>
                        <mat-datepicker #pickerStart></mat-datepicker>
                        <mat-hint>Vanaf deze dag actief.</mat-hint>
                        <mat-error [control]="form().get('start_date')"></mat-error>
                    </mat-form-field>
                </app-field>
                <app-field for="end_date" label="Einddatum" optional>
                    <mat-form-field>
                        <input (focus)="pickerEnd.open()" [matDatepicker]="pickerEnd" [min]="minDate" formControlName="end_date" id="end_date" matInput placeholder="Einddatum">
                        <mat-datepicker-toggle [for]="pickerEnd" matSuffix></mat-datepicker-toggle>
                        <mat-datepicker #pickerEnd></mat-datepicker>
                        <mat-hint>Leeg laten = blijft actief.</mat-hint>
                        <mat-error [control]="form().get('end_date')"></mat-error>
                    </mat-form-field>
                </app-field>
            </app-section>
        </div>

        @if (Features.PlatformsSave | hasFeature) {
            <app-sticky-save-bar (cancel)="cancel()" (save)="save()" [dirty]="formState().dirty" [valid]="formState().valid">
                @if (form().get('id').value && (Features.PlatformsDetailDelete | hasFeature)) {
                    <ng-container *ngTemplateOutlet="deleteButton"></ng-container>
                }
            </app-sticky-save-bar>
        } @else if (form().get('id').value && (Features.PlatformsDetailDelete | hasFeature)) {
            <div class="d-flex justify-content-end">
                <ng-container *ngTemplateOutlet="deleteButton"></ng-container>
            </div>
        }
    }
</app-page>

<ng-template #deleteButton>
    <button (click)="openDelete($event)" class="ui-error" mat-button type="button">
        <i class="fa-regular fa-trash-can me-1"></i> Verwijderen
    </button>
</ng-template>
